import { render } from 'react-dom';
import { connect } from 'lape';
import './state/router';
import * as React from 'react';
import styled from 'styled-components';
import stateComponents from '@state/components';
import HomePage from './editor/HomePage/HomePage';
import Docs from './editor/HomePage/Docs';
import Fonts from './editor/Settings/Fonts/Fonts';
import LeftMenu from './editor/LeftMenu/LeftMenu';
import ColorsAndSpacing from './editor/Settings/Styles/ColorsAndSpacing';
import Exporting from '@src/editor/Settings/Exporting/Exporting';
import Assets from '@src/editor/Settings/Assets/Assets';
import Elements from '@src/editor/Elements/Elements';
import { connectDevTools } from '@src/utils';
import AddingAtom from '@src/editor/Elements/Overlay/AddingAtom';
import { matches, paths } from '@state/router';
const Root = styled.div `
  display: flex;
  min-height: 100%;
  user-select: none;
`;
const Editor = () => {
    return (React.createElement(Root, null,
        React.createElement(LeftMenu, null),
        matches(paths.homepage) && React.createElement(HomePage, null),
        matches(paths.docs) && React.createElement(Docs, null),
        matches(paths.element) && React.createElement(Elements, null),
        matches(paths.color) && React.createElement(ColorsAndSpacing, null),
        matches(paths.font) && React.createElement(Fonts, null),
        matches(paths.export) && React.createElement(Exporting, null),
        matches(paths.assets) && React.createElement(Assets, null),
        React.createElement(AddingAtom, null)));
};
connectDevTools(stateComponents);
export default Editor;
if (module.hot) {
    module.hot.accept();
}
const WrappedRoot = connect(Editor);
render(React.createElement(WrappedRoot, null), document.getElementById('editor'));
